export function isPolygonFeature(
  feature: GeoJSON.Feature | undefined | null,
): feature is GeoJSON.Feature<GeoJSON.Polygon> {
  return feature?.geometry.type === "Polygon";
}

/**
 * Checks if a GeoJSON feature with Polygon geometry has valid coordinates.
 * A valid polygon must:
 * - Have geometry type "Polygon"
 * - Have coordinates array
 * - Have at least one ring (coordinates[0])
 * - Have at least 3 points in the first ring (minimum for a valid polygon)
 * @param feature - GeoJSON feature to validate
 * @returns true if the polygon has valid coordinates, false otherwise
 */
export function isValidPolygon(
  feature: GeoJSON.Feature | null,
): feature is GeoJSON.Feature<GeoJSON.Polygon> {
  if (!feature) return false;

  if (feature.geometry.type !== "Polygon") return false;

  const coordinates = feature.geometry.coordinates;
  if (!coordinates || coordinates.length === 0) return false;

  const firstRing = coordinates[0];
  if (!firstRing || firstRing.length < 3) return false;

  return firstRing.every(
    (position) =>
      Array.isArray(position) &&
      position.length >= 2 &&
      typeof position[0] === "number" &&
      Number.isFinite(position[0]) &&
      typeof position[1] === "number" &&
      Number.isFinite(position[1]),
  );
}

